import './chunk-851d1b8f.js';
import './helpers.js';
import './chunk-e92e3389.js';
import './chunk-6ca75105.js';
import './chunk-4b289821.js';
import { r as registerComponent, u as use } from './chunk-cca88db8.js';
import './chunk-d77d421b.js';
import { A as Autocomplete } from './chunk-9bd1f33e.js';
export { A as BAutocomplete } from './chunk-9bd1f33e.js';

var Plugin = {
  install: function install(Vue) {
    registerComponent(Vue, Autocomplete);
  }
};
use(Plugin);

export default Plugin;



//////////////////
// WEBPACK FOOTER
// ./node_modules/buefy/dist/esm/autocomplete.js
// module id = null
// module chunks = 